<template>
  <div :class="`level level-${level}`">
    <div
      :key="index"
      :class="`menu_item ${
        path === menuItem?.url || isSelected || isAssessChecklist()
          ? 'active'
          : ''
      } ${
        menuItem?.children && isSelected ? 'has-child expand' : ''
      } ${getClassActive()}`"
      @click="selectItem"
    >
      <div class="item">
        <img
          v-if="level === 0 && menuItem?.icon"
          :src="menuItem?.icon"
          alt="icon"
        />
        <span v-else-if="level === 1" class="circle-icon" />
        <span
          id="item-name"
          :data-cy="`item-collapsibale-${menuItem?.dataCy}`"
          :class="`item-name ${danger ? 'danger' : ''} ${
            path === menuItem?.url || isSelected || isAssessChecklist()
              ? 'active'
              : ''
          }`"
          >{{ menuItem?.title }}</span
        >
      </div>
      <ArrowIcon
        v-if="level === 0 && !isSubscriptionTab()"
        class="right-arrow"
        :color="danger ? '#F7553C' : undefined"
        :width="6.661"
        :height="10"
      />

      <svg
        v-if="isSubscriptionTab() && !isLoadingStripURL"
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
      >
        <path
          d="M11.6251 0.500122H7.62519C7.55071 0.50002 7.47794 0.522396 7.41639 0.564323C7.35484 0.606249 7.30737 0.665776 7.2802 0.735116C7.25178 0.80293 7.24422 0.877673 7.25846 0.949805C7.27271 1.02194 7.30813 1.08819 7.3602 1.14011L9.00015 2.75506L4.27528 7.40495C4.18215 7.49862 4.12988 7.62535 4.12988 7.75744C4.12988 7.88953 4.18215 8.01625 4.27528 8.10993C4.32158 8.15717 4.3768 8.19475 4.43774 8.2205C4.49867 8.24625 4.56411 8.25965 4.63027 8.25992C4.76073 8.26071 4.88633 8.21047 4.98026 8.11993L9.72014 3.45505L11.3651 5.07501C11.3997 5.11006 11.441 5.13785 11.4865 5.15674C11.532 5.17562 11.5808 5.18524 11.6301 5.185C11.68 5.18516 11.7294 5.17494 11.7751 5.155C11.8426 5.12627 11.9 5.07813 11.94 5.01671C11.9801 4.95528 12.001 4.88334 12.0001 4.81001V0.875113C11.9988 0.776062 11.9589 0.681432 11.8888 0.611387C11.8188 0.541341 11.7241 0.501417 11.6251 0.500122Z"
          fill="#387DFF"
        />
        <path
          d="M9.24976 5.81004C9.11716 5.81004 8.98998 5.86272 8.89622 5.95649C8.80245 6.05025 8.74978 6.17743 8.74978 6.31003V11.4999H0.999974V3.7501H6.18484C6.31745 3.7501 6.44462 3.69742 6.53839 3.60365C6.63215 3.50989 6.68483 3.38271 6.68483 3.25011C6.68483 3.1175 6.63215 2.99033 6.53839 2.89657C6.44462 2.8028 6.31745 2.75012 6.18484 2.75012H0.934976C0.687005 2.75012 0.44919 2.84863 0.273848 3.02397C0.0985061 3.19931 0 3.43713 0 3.6851L0 11.5599C-3.51443e-06 11.8083 0.0983428 12.0467 0.273543 12.2228C0.448742 12.3989 0.686546 12.4986 0.934976 12.4999H8.80977C9.05907 12.4999 9.29816 12.4008 9.47444 12.2246C9.65072 12.0483 9.74975 11.8092 9.74975 11.5599V6.31003C9.74975 6.17743 9.69707 6.05025 9.60331 5.95649C9.50954 5.86272 9.38237 5.81004 9.24976 5.81004Z"
          fill="#387DFF"
        />
      </svg>

      <div
        v-if="isSubscriptionTab() && isLoadingStripURL"
        style="margin-top: -15px"
        class="tw-h-[10px] tw-w-[30px]"
      >
        <!-- eslint-disable vue/no-unused-refs -->
        <LottieAnimation
          ref="anim"
          :animation-data="getProgressAnimation()"
          :auto-play="true"
          :loop="true"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { useRoute } from "vue-router";
import ArrowIcon from "@/components/svgs/arrowIcon.vue";
import { routers } from "@/utils/constants";
import store from "@/store";
import { getComponentUiText, getProgressAnimation } from "@/utils/utilities";
import { showErrorAPI } from "@/services/apiRoutes";
import { getSessionPortal } from "@/services/subscriptions";
import { Subscription } from "@/services/apiRoutes/routes";
import { LottieAnimation } from "lottie-web-vue";

export type CollapsableMenuItemType = {
  icon?: string;
  title: string;
  children?: Array<CollapsableMenuItemType>;
  url?: string;
  id?: string;
  parentId?: string;
  parentTitle?: string;
  danger?: boolean;
  description?: string;
  instruction?: string;
  instructionTitle?: string;
  logo?: any;
  dataCy?: string;
};

@Component({
  components: {
    ArrowIcon,
    LottieAnimation,
  },
})
export default class CollapsableMenuItem extends Vue {
  @Prop({ required: true }) readonly menuItem: CollapsableMenuItemType | null =
    null;

  @Prop({ required: true }) readonly index: number = 0;

  @Prop({ default: 0 }) readonly level: number = 0;

  @Prop({ required: true, default: false }) isSelected = false;

  @Prop({ required: false, default: false }) readonly danger: boolean = false;

  private route = useRoute();
  isLoadingStripURL = false;
  get path() {
    return this.route.path;
  }

  getProgressAnimation() {
    return getProgressAnimation();
  }

  isSubscriptionTab() {
    return (
      this.menuItem?.title ===
      getComponentUiText("app-menu-submenu-settings-subscription-1")
    );
  }

  mounted() {
    if (this.path === this.menuItem?.url) {
      this.$emit(
        "select-item",
        this.level,
        this.menuItem?.id,
        this.menuItem?.title,
        this.menuItem?.parentTitle,
        this.index,
        this.menuItem?.parentId,
        true,
      );
    }
  }

  public isAssessChecklist() {
    return (
      this.path === routers.assessChecklist &&
      this.menuItem?.url === routers.assessCreate
    );
  }
  public getClassActive() {
    if (this.isAssessChecklist()) return "active";
    return this.path === this.menuItem?.url || this.isSelected
      ? "active disable-mouse-events"
      : "";
  }
  public async selectItem() {
    if (this.isSubscriptionTab()) {
      try {
        {
          this.isLoadingStripURL = true;
          const clientSecretResponse = await getSessionPortal("dashboard");
          const sessionPortalUrl =
            clientSecretResponse.data?.data?.redirectUrl || "";
          if (!sessionPortalUrl) {
            showErrorAPI("app-settings-subscription-error-text-1", "error");
            this.isLoadingStripURL = false;
            return;
          }
          window.location.href = sessionPortalUrl;
          setTimeout(() => {
            this.isLoadingStripURL = false;
          }, 1000);
          return;
        }
      } catch (error) {
        // showErrorAPI(error, Subscription.getSessionPortal);
      }
    }
    this.$emit(
      "select-item",
      this.level,
      this.menuItem?.id,
      this.menuItem?.title,
      this.menuItem?.parentTitle,
      this.index,
      this.menuItem?.parentId,
    );
    this.$emit("leaf-item-selected");

    for (let i = this.level + 1; i < 3; i++) {
      this.$emit("select-item", i, "", "", "", this.index, "", true);
    }

    if (this.menuItem?.url) {
      if (this.menuItem?.url === routers.settingsSetup)
        store.dispatch("SetupWizard/onModalSetupWizard", true);

      this.$router.push({ path: this.menuItem.url });
    }
  }
}
</script>

<style scoped>
.active {
  background: #fcfcfd;
}
.level .menu_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  cursor: pointer;
}

.level .menu_item .item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.level .menu_item:hover img,
.level .menu_item:focus img,
.level:not(:has(.has-child, .click-none)) .menu_item.active img {
  filter: invert(45%) sepia(91%) saturate(3697%) hue-rotate(208deg)
    brightness(103%) contrast(98%);
}

.danger_filter {
  filter: invert(40%) sepia(54%) saturate(2830%) hue-rotate(340deg)
    brightness(103%) contrast(94%) !important;
}

.level .menu_item .right-arrow {
  transition: transform 0.3s ease-in-out;
}

.level .menu_item.has-child.expand .right-arrow {
  transform: rotate(90deg);
}

.level-1:not(:has(.has-child)) .menu_item.active .item-name.active {
  color: #387dff;
}

.level-0 .menu_item.active .item-name.active {
  color: #387dff;
}

.level-1 .menu_item {
  margin: 0px 17px;
}

.level-0:hover .menu_item .item .item-name {
  color: #387dff;
}

.level-0:active .menu_item .item .item-name {
  color: #0345bd;
}

.level-0:active .menu_item {
  background: rgba(228, 241, 255, 1);
}
.level-0:active .item-name {
  background: rgba(228, 241, 255, 1);
}

.level .menu_item .item img {
  width: 15px;
  height: 15px;
}

.level .menu_item .item .item-name {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 100%;
  background-color: none;
  /* identical to box height, or 15px */

  /* brand/Navy */

  color: #211f58;
}

.level .menu_item .item .item-name.danger {
  color: #f7553c;
}

.level .menu_item .right-arrow {
  width: 10px !important;
  height: 7px !important;
}

.level-1 .circle-icon {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #387dff;
}

.level-1 .menu_item {
  height: 18px;
  padding: 3px 6px;
  width: fit-content;
  border-radius: 100px;
}

.level-1 .menu_item .item {
  padding: 0px;
  gap: 10px;
}

.level-1 .menu_item .item .item-name {
  font-size: 12px;
  color: #231f20;
  flex: 1;
}

.level-1:has(.has-child) .menu_item .item {
  background: rgba(3, 69, 189, 0.07);
  border-radius: 100px;
  padding: 4px 8px;
}

.level-1:hover .menu_item .item .item-name {
  color: rgba(56, 125, 255, 1);
}

.level-1:hover .menu_item {
  background: white !important;
}

.level-1:active .menu_item .item .item-name {
  color: rgba(3, 69, 189, 1);
}

.level-1:active .menu_item {
  background: rgba(228, 241, 255, 1) !important;
}
.level-2 .menu_item {
  height: 12px;
}

.level-2 .menu_item .item {
  padding: 0px;
  gap: 10px;
}

.level-2 .menu_item .item .item-name {
  font-size: 12px;
  height: 12px;
  color: #878787;
  flex: 1;
}

.disable-mouse-events {
  pointer-events: none;
}
</style>
